var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-modal",
    { attrs: { width: "450px" } },
    [
      _c("samc-modal-header", [
        _vm._v(
          _vm._s(_vm.tradingAccount === null ? "Add New" : "Edit") +
            " Trading Account"
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 pb-2" },
        [
          _c(
            "samc-field",
            {
              attrs: {
                label: "Account",
                disabled: _vm.tradingAccount !== null,
                "error-message": _setup.showValidations
                  ? _setup.validations.account
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.account,
                    expression: "account",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.account },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.account = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "samc-field",
            {
              attrs: {
                label: "Description",
                "error-message": _setup.showValidations
                  ? _setup.validations.description
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.description,
                    expression: "description",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.description },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.description = $event.target.value
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid gap-4 grid-cols-2 pb-2" },
        [
          _c(
            "samc-field",
            {
              attrs: {
                label: "Book ID",
                "error-message": _setup.showValidations
                  ? _setup.validations.bookId
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.bookId,
                    expression: "bookId",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.bookId },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.bookId = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "samc-field",
            {
              attrs: {
                label: "Reference ID",
                "error-message": _setup.showValidations
                  ? _setup.validations.referenceId
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.referenceId,
                    expression: "referenceId",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.referenceId },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.referenceId = $event.target.value
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 pb-2" },
        [
          _c(
            "samc-field",
            {
              attrs: {
                label: "Type",
                "error-message": _setup.showValidations
                  ? _setup.validations.accountType
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.accountType,
                    expression: "accountType",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.accountType },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.accountType = $event.target.value
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "samc-field",
            {
              attrs: {
                label: "Product Type",
                "error-message": _setup.showValidations
                  ? _setup.validations.productType
                  : "",
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _setup.productType,
                    expression: "productType",
                  },
                ],
                attrs: { type: "text" },
                domProps: { value: _setup.productType },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _setup.productType = $event.target.value
                  },
                },
              }),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "samc-modal-actions",
        [
          _c(
            "samc-button",
            {
              attrs: { type: "secondary" },
              on: {
                click: function ($event) {
                  return _setup.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c(
            "samc-button",
            {
              on: {
                click: function ($event) {
                  return _setup.save()
                },
              },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }